module.exports = __webpack_public_path__ + "static/media/ears.7b802a89.png";